import { useContext } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import Button from '../../atoms/button/button';
import image from '../../../assets/images/no-load.svg';
import './login-request.scss';
import { graphql, useStaticQuery } from 'gatsby';

const LoginRequest = () => {
    const { gigyaContext } = useContext(GlobalContext);

    const data = useStaticQuery(graphql`
        query GET_LOGIN_REQUEST_DATA {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Pantalla lo sentimos necesitas iniciar sesión"
                    }
                }
            ) {
                nodes {
                    nombre
                    subtitulo
                    imagen {
                        title
                        file {
                            url
                        }
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            copyBoton
                            redireccion
                        }
                    }
                }
            }
        }
    `);

    const content = data.allContentfulTemplate.nodes[0];

    const triggerLogIn = () => {
        gigyaContext.login();
    };

    return (
        <div className="o-login-request">
            <div className="o-login-request__content">
                <img
                    className="o-login-request__img"
                    src={
                        content && content.imagen
                            ? content.imagen[0].file.url
                            : image
                    }
                    aria-hidden={
                        content && content.imagen
                            ? content.imagen[0].title
                            : 'we are sorry image'
                    }
                />
                <h1 className="o-login-request__title">
                    {content && content.nombre
                        ? content.nombre
                        : 'Lo sentimos, necesitas iniciar sesión para acceder este beneficio'}
                </h1>
                {content && content.subtitulo && (
                    <p className="o-login-request__description">
                        {content.subtitulo}
                    </p>
                )}
                <div className="o-login-request__btn">
                    <Button
                        type="button"
                        classname="secondary o-login-request__btn-back"
                        text={
                            content &&
                            content.referencias &&
                            content.referencias[0].copyBoton
                                ? content.referencias[0].copyBoton
                                : 'INICIAR SESIÓN'
                        }
                        isDisabled={false}
                        onClickAction={triggerLogIn}
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginRequest;
